import {StateChanges, StateSaver, BlankState} from './stateChanges' // , BlankState
// import {RunStates} from './runStates'
// import router from '../router'
// import savedExperiments from './savedExperimentUtils'
import firebase from 'firebase/app'
import 'firebase/auth'
import {firebaseStore} from './firebaseModule'
// import defaultSettings from './defaultSettings'
// import {resetAfterFeatureChanges, resetResultsAndMarkUnsaved, resetTestResultsAndMarkUnsaved} from './resetState'
// import treeService from '../texts/treeService'
// function gtag () { window.dataLayer.push(arguments) }
import {toUserDictionaryObjForm} from '../js/toUserDictionaryObjForm'

const FIREBASE_KEY_BADCHARS = [".", "#", "$", "/", "[", "]", "\n"]

const accountMutations = {
  [StateChanges.LOGIN_REQUESTED] (state) {
    state.loginInProgress = true
    StateSaver.saveState(state)
  },
  [StateChanges.LOGIN_COMPLETE] (state) {
    firebaseStore('permissionToUseData', 
      window.localStorage.hasOwnProperty('permission-to-use-pro-nakdan-data') ?
        window.localStorage['permission-to-use-pro-nakdan-data'] : 'false')
    state.loginInProgress = false
    state.isLoggedIn = true
    const allUserData = firebase.auth().currentUser
    // console.log('allUserData:')
    // console.log(allUserData)
    state.userData = {
      name: allUserData.displayName,
      email: allUserData.email,
      passWordedAccount: allUserData.providerData[0].providerId === 'password'
    }
    StateSaver.saveState(state)
  },
  [StateChanges.LOGIN_CANCELLED] (state) {
    state.loginInProgress = false
    StateSaver.saveState(state)
  },
  [StateChanges.LOGIN_CONTINUING] (state) {
    state.loginInProgress = true
  },
  [StateChanges.LOGGED_OUT] (state) {
    state.isLoggedIn = false
    state.userData = null
    state.userDictionary = JSON.parse(JSON.stringify(BlankState.userDictionary))
    StateSaver.saveState(state)
  },
  [StateChanges.CHANGE_USER_PASSWORD] (state, args) {
    var user = firebase.auth().currentUser
    user.updatePassword(args.newPassword).then(function() {
      // console.log('Password update successful.')
      args.out.result = 'success'
    }).catch(function(error) {
      // console.error('Error while attempting to update password:', error)
      args.out.result = error.message
    })
  },
  [StateChanges.FIREBASE_RECEIVED_UPDATE] (state, {listName, value}) {
    if (listName === 'dictionary') {
      var newUserDictionary = value ?
        (Array.isArray(value) ? toUserDictionaryObjForm(value, []) : value) : JSON.parse(JSON.stringify(BlankState.userDictionary))
      if (!(newUserDictionary.hasOwnProperty('entryPresent'))
          && !(newUserDictionary.hasOwnProperty('lettersMap'))) {
        newUserDictionary['entryPresent'] = {}
        newUserDictionary['lettersMap'] = {}
      }
      if (!(newUserDictionary.hasOwnProperty('negativeEntryPresent'))
          && !(newUserDictionary.hasOwnProperty('negativeLettersMap'))) {
        newUserDictionary['negativeEntryPresent'] = {}
        newUserDictionary['negativeLettersMap'] = {}
      }
      if (!(Object.values(newUserDictionary.lettersMap).every(a => a.every(e => 
                                    FIREBASE_KEY_BADCHARS.every(badChar => !(e.includes(badChar))))))) {
        Object.keys(newUserDictionary.lettersMap).forEach(k => {
          if (!(FIREBASE_KEY_BADCHARS.every(badChar => !(k.includes(badChar))))) {
            delete newUserDictionary.lettersMap[k]
          } else newUserDictionary.lettersMap[k] = newUserDictionary.lettersMap[k].filter(e => FIREBASE_KEY_BADCHARS.every(badChar => !(e.includes(badChar))))
        })
        Object.keys(newUserDictionary.entryPresent).forEach(k => {
          if (!(FIREBASE_KEY_BADCHARS.every(badChar => !(k.includes(badChar))))) delete newUserDictionary.entryPresent[k]
        })
      }
      if (!(Object.values(newUserDictionary.negativeLettersMap).every(a => a.every(e => 
                                    FIREBASE_KEY_BADCHARS.every(badChar => !(e.includes(badChar))))))) {
        Object.keys(newUserDictionary.negativeLettersMap).forEach(k => {
          if (!(FIREBASE_KEY_BADCHARS.every(badChar => !(k.includes(badChar))))) {
            delete newUserDictionary.negativeLettersMap[k]
          } else newUserDictionary.negativeLettersMap[k] = newUserDictionary.negativeLettersMap[k].filter(e => FIREBASE_KEY_BADCHARS.every(badChar => !(e.includes(badChar))))
        })
        Object.keys(newUserDictionary.negativeEntryPresent).forEach(k => {
          if (!(FIREBASE_KEY_BADCHARS.every(badChar => !(k.includes(badChar))))) delete newUserDictionary.negativeEntryPresent[k]
        })
      }
      state.userDictionary = newUserDictionary
    }
  }
}

export default accountMutations
